exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".head {\n    padding: 16px 20px;\n    margin-bottom: 0;\n    font-size: 18px;\n    font-weight: 400;\n    line-height: 22px;\n    cursor: pointer;\n}\n.poll-add-data {\n    \n    padding-top: 15px;\n    margin-top: 15px;\n    clear: both;\n}\n.content-btn-grp input {\n    width: calc(100% - 40px);\n    height: 40px;\n    border: 1px solid #ddd;\n    display: inline-block;\n    vertical-align: middle;\n}\n.poll-add-data .iconButton {\n    float: none;\n    display: inline-block;\n    vertical-align: middle;\n}\n.form-group {\n    padding: 16px 20px;\n    margin: 0;\n}\n.form-question-bg {\n    padding-top: 0 !important;\n}\n.form-question-bg span {\n    padding-bottom: 10px;\n    display: block;\n}\n.poll-add-bg .form-group {\n    margin: 0 !important;\n}\n.poll-top-check {\n    padding: 16px 20px 0;\n}\n\n.mar-left-100 {\n\tmargin-left:100px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/event/poll-add/poll-add.component.css
// module id = ../../../../../src/app/event/poll-add/poll-add.component.css
// module chunks = main